export default __webpack_public_path__ + "static/media/boom.89a0ee30.wav";